import { useReducer } from 'react';
import { TablePaginatorOptions } from '../../../../utils/consts';
import { DirectionOptions } from '../../../../utils/enums';
import { Campus, PageResult } from '../../../../utils/models';
import { CampusTableColumn } from '../enums/CampusTableColumn';
import { CampusState, ModalRecordCampus } from '../interfaces/interfaces';
import { CampusContext } from './CampusContext';
import { campusReducer } from './campusReducer';

const INITIAL_STATE_PERIOD: CampusState = {
  campusList: [],
  page: 1,
  paginatorOptions: new PageResult<Campus[]>(),
  rowsPerPage: TablePaginatorOptions.rowsPerPageDefault,
  search: '',
  orderBy: CampusTableColumn.CLAVE,
  dir: DirectionOptions.ASC,
  modalRecord: {
    show: false,
    campusEdit: null,
    type: 'add',
  },
};

interface props {
  children: JSX.Element | JSX.Element[];
}

export const CampusProvider = ({ children }: props) => {
  const [campusState, dispatch] = useReducer(
    campusReducer,
    INITIAL_STATE_PERIOD,
  );

  const reloadCampus = (campusList: Campus[]) => {
    dispatch({ type: 'reloadCampus', campusList });
  };

  const changePage = (page: number) => {
    dispatch({ type: 'changePage', page });
  };

  const changeStatus = (status: boolean, campus: Campus) => {
    dispatch({ type: 'changeStatus', status, campus });
  };

  const changePaginatorOptions = (paginatorOptions: PageResult<Campus[]>) => {
    dispatch({ type: 'changePaginatorOptions', paginatorOptions });
  };

  const changeRowsPerPage = (rowsPerPage: any) => {
    dispatch({ type: 'changeRowsPerPage', rowsPerPage });
  };

  const changeSearch = (search: string) => {
    dispatch({ type: 'changeSearch', search });
  };

  const changeModalRecord = (modalRecord: ModalRecordCampus) => {
    dispatch({ type: 'changeModalRecord', modalRecord });
  };
  const setOrder = (orderBy: CampusTableColumn, dir: DirectionOptions) => {
    dispatch({ type: 'setOrder', orderBy, dir });
  };

  return (
    <CampusContext.Provider
      value={{
        campusState,
        reloadCampus,
        changePage,
        changeStatus,
        changePaginatorOptions,
        changeRowsPerPage,
        changeSearch,
        changeModalRecord,
        setOrder,
      }}>
      {children}
    </CampusContext.Provider>
  );
};
